function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }


function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
  }

  function deleteCookie(cname) {
    document.cookie = cname+"=;path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
  }




const getCookieV3 = (name) => {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    let [key, value] = cookie.split("=");
    if (key === name) {
      return JSON.parse(decodeURIComponent(value)); // Convert string back to object
    }
  }
  return null;
};
 const setCookieV3 = (cname, cvalue, exdays, domain) => {
  if (!domain) {
    domain = window.location.hostname.includes("localhost") ? "" : window.location.hostname;
  } else if (window.location.hostname.includes("localhost")) {
    domain = "";
  }
  let d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = `expires=${d.toUTCString()}`;
  let cookieString = `${cname}=${encodeURIComponent(cvalue)}; ${expires}; path=/`;
  if (domain) {
    cookieString += `; domain=${domain}`;
  }
  // Optional: Secure cookies on HTTPS
  if (window.location.protocol === "https:") {
    cookieString += "; Secure; SameSite=Lax";
  }
  document.cookie = cookieString;
};


export const getChangeToken = ()=> {
  return getCookie('change-token')  || "";
}

  export {getCookie, setCookie, deleteCookie ,
    getCookieV3,
    setCookieV3
  };
